var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.spacing],style:(_vm.mainCssVars)},[_c('grid',{class:[{ 'grid--container': !_vm.fullwidth }, `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        rows: _vm.getRows,
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        rows: _vm.getRows,
        gap: '10px',
      },
    ]}},[(_vm.leftQuote)?_c('grid-item',{class:[
        `${_vm.name}__grid-item`,
        `${_vm.name}__quote`,
        `${_vm.name}__quote--left`,
        _vm.leftQuote,
      ],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 1, width: 2, y: 1 },
        { size: 3, x: 3, width: 4, y: 1 },
        { size: 4, x: 8, width: 2, y: 1 },
      ]}}):_vm._e(),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__content`],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 3, width: 8, y: 2 },
        { size: 3, x: 5, width: 14, y: 2 },
        { size: 4, x: 10, width: 10, y: 2 },
      ]}},[_c('a-copy',{class:[`${_vm.name}__text`, `${_vm.name}__quotation`],attrs:{"cms":_vm.cms}}),_vm._v(" "),(_vm.cms.citation)?_c('div',{class:[`${_vm.name}__text`, `${_vm.name}__citation`],domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.cms.citation))}}):_vm._e()],1),_vm._v(" "),(_vm.rightQuote)?_c('grid-item',{class:[
        `${_vm.name}__grid-item`,
        `${_vm.name}__quote`,
        `${_vm.name}__quote--right`,
        _vm.rightQuote,
      ],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 11, width: 2, y: 3 },
        { size: 3, x: 19, width: 4, y: 3 },
        { size: 4, x: 20, width: 2, y: 3 },
      ]}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }